import { findLastIndex } from "lodash";

export function takeUntilLast<T>(arr: T[], predicate: (val: T) => boolean) {
  const lastMatch = findLastIndex(arr, predicate);
  return arr.slice(0, lastMatch + 1);
}
